"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _merchant = require("@/api/merchant");
var _user = require("@/api/user");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'benefitsEdit',
  props: {
    //是否显示隐藏
    drawerVisible: {
      type: Boolean,
      default: false
    },
    pramInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      pram: {
        channelStrList: [],
        channelStr: '',
        expand: '',
        id: 0,
        imageUrl: '',
        message: '',
        multiple: 1,
        name: '',
        sort: 0,
        status: true,
        value: ''
      },
      rules: {
        value: [{
          required: true,
          message: '请输入展示名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 6,
          message: '长度在 1 到 6 个字符',
          trigger: 'blur'
        }],
        imageUrl: [{
          required: true,
          message: '请上传权益图标',
          trigger: 'change'
        }],
        message: [{
          required: true,
          message: '请输入权益简介',
          trigger: 'blur'
        }],
        channelStrList: [{
          type: 'array',
          required: true,
          message: '请至少选择一个渠道',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.pram = Object.assign({}, this.pramInfo);
    this.pram.channelStrList = this.pram.channelStr ? _toConsumableArray(this.pram.channelStr.split(',')) : [];
  },
  methods: {
    checkPermi: _permission.checkPermi,
    checkedBoxChange: function checkedBoxChange() {
      this.$forceUpdate(); //强制渲染多选框样式，否则值变了样式没有选中
    },
    handleClose: function handleClose() {
      this.$emit('onClosedrawerVisible');
    },
    modalPicTap: function modalPicTap(multiple) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.pram.imageUrl = img[0].sattDir;
      }, multiple, 'content');
    },
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.pram.validate(function (valid) {
        if (valid) {
          if (!_this2.pram.channelStrList.length && (_this2.pram.name === 'integralDoubling' || _this2.pram.name === 'experienceDoubling')) return _this2.$modal.msgWarning('翻倍渠道至少需要选中一项');
          _this2.pram.channelStr = _this2.pram.channelStrList.join(',');
          (0, _user.memberBenefitsEditApi)(_this2.pram).then(function (response) {
            _this2.$modal.msgSuccess('保存成功');
            _this2.$forceUpdate();
            _this2.$emit('subSuccess');
          });
        }
      });
    }
  }
};